import { Spin } from "antd";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useAuth } from "./auth/AuthContext";
import { AppLayout } from "./components/AppLayout";
import { PolicyGate } from "./components/PolicyGate";
import LoginPage from "./pages/LoginPage";
import SsoCallbackPage from "./pages/SsoCallbackPage";
import AcceptInvitePage from "./pages/AcceptInvitePage";
import DashboardPage from "./pages/DashboardPage";
import PlanPage from "./pages/PlanPage";
import SuppliersPage from "./pages/SuppliersPage";
import SupplierPage from "./pages/SupplierPage";
import FactoryPage from "./pages/FactoryPage";
import EvidencePage from "./pages/EvidencePage";
import AuditsPage from "./pages/AuditsPage";
import AuditPage from "./pages/AuditPage";
import NcsPage from "./pages/NcsPage";
import ActionsPage from "./pages/ActionsPage";
import ReportsPage from "./pages/ReportsPage";
import AdminPage from "./pages/AdminPage";
import ForgotPage from "./pages/ForgotPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import SecurityPage from "./pages/SecurityPage";
import McpAuthorizePage from "./pages/McpAuthorizePage";

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { me, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <Spin fullscreen />;
  if (!me) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  // Ruolo con TOTP obbligatorio non ancora configurato: sessione limitata, si va alla pagina Sicurezza.
  if (me.mfa?.setupNeeded && loc.pathname !== "/security") return <Navigate to="/security" replace />;
  return <PolicyGate>{children}</PolicyGate>;
}

function Home() {
  const { me } = useAuth();
  if (me?.role === "supplier") return <Navigate to={`/suppliers/${me.supplierId}`} replace />;
  return <DashboardPage />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/sso/callback" element={<SsoCallbackPage />} />
      <Route path="/mcp/authorize" element={<McpAuthorizePage />} />
      <Route path="/invite/:token" element={<AcceptInvitePage />} />
      <Route path="/forgot" element={<ForgotPage />} />
      <Route path="/reset/:token" element={<ResetPasswordPage />} />
      <Route
        element={
          <RequireAuth>
            <AppLayout />
          </RequireAuth>
        }
      >
        <Route index element={<Home />} />
        <Route path="plan" element={<PlanPage />} />
        <Route path="suppliers" element={<SuppliersPage />} />
        <Route path="suppliers/:id" element={<SupplierPage />} />
        <Route path="factories/:id" element={<FactoryPage />} />
        <Route path="evidence/:id" element={<EvidencePage />} />
        <Route path="audits" element={<AuditsPage />} />
        <Route path="audits/:id" element={<AuditPage />} />
        <Route path="ncs" element={<NcsPage />} />
        <Route path="actions" element={<ActionsPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="admin" element={<AdminPage />} />
        <Route path="security" element={<SecurityPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
